<template>
    <div class="carbonsaeureester">
        <ul>
            <li>RCOOR'</li>
            <li>-ester</li>
            <li>"Verseifung" zu RCOONa</li>
        </ul>
        <img
            src="@/assets/img/stoffe/ester/teile.png"
            alt="Die Teile der Ester"
            title="Die Teile der Ester"
        />
    </div>
</template>

<script>
export default {
    name: 'carbonsaeureester',
};
</script>
